import axios from 'axios';

// Centraliza a configuração do Axios e expõe a baseURL
// Em desenvolvimento, sem VITE_API_URL, usa '/api' para acionar o proxy do Vite
const envUrl = (import.meta.env.VITE_API_URL || '').trim();
const baseURL = envUrl || '/api';

// Se não houver baseURL, usa caminhos relativos (mesma origem)
const api = axios.create({ baseURL });

const getToken = () => {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthRoute =
      url.includes('/user/signin') ||
      url.includes('/user/signup') ||
      url.includes('/user/login') ||
      url.includes('/user/register');

    if (status === 401 && !isAuthRoute) {
      try {
        localStorage.removeItem('token');
      } catch {
        // no-op
      }
      if (typeof window !== 'undefined') {
        window.location.assign('/');
      }
    }
    return Promise.reject(error);
  }
);

export { baseURL };
export default api;
